import { ProductBundle } from '@typesApp/Product'

export const isProductInsuranceEligible = (product: ProductBundle): boolean => {
  return product.cartProducts?.some(p => p.insuranceEligible)
}
